<template id="loginvue">
    <div class="wrapper fadeInDown">
  <div id="formContent">
    <!-- Tabs Titles -->
    <h2 class="active"> Iniciar Sesión</h2>

    <!-- Icon -->
    <div class="fadeIn first">
      <img src="@/assets/login.svg" id="icon" alt="User Icon" />
    </div>

    <!-- Login Form -->
    <form v-on:submit.prevent="autenticacion">
      <input type="text" v-model="user.usuario"  id="login" class="fadeIn second" name="login" placeholder="Usuario" autofocus>
      <input type="password" v-model="user.password"   id="password" class="fadeIn third" name="login" placeholder="Contraseña">
      <input type="submit" class="fadeIn fourth" value="INGRESAR">
    </form>

    <!-- Remind Passowrd -->
    <div id="formFooter">
      <a class="underlineHover" href="#">Microsystems App {{getVersionApp}}</a>
    </div>

  </div>
  <ul class="circles">
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
            </ul>
</div>
  </template>
  
  <script>
import axios from 'axios'
import Swal from 'sweetalert2'
//import {Cryptr} from 'cryptr'
//require('@/assets/styles/style.css')

export default {
    name:'LoginUser',
      
    data: () => ({
    //Login
    show:false,
    spinner:false, 
    user:{
        usuario:'',
        password:'',
    }
    }),
    computed:{
        urlApi(){
           return this.$store.getters.getUrlApi
        },
        getVersionApp(){
            return this.$store.getters.getVersionApp
        }
    },
    methods:{
      autenticacion(){
          this.spinner=true
         axios.post(`${this.urlApi}/auth/login`,this.user).then(res=>{
             if(res.status==201){
                this.spinner=false
                this.$store.dispatch('setTokenUser',res.data.accessToken)
                this.$store.dispatch("postAutenticacion",res.data)
                this.$router.push(res.data.usuario.usuariopermiso[0].path)
             }else{
                 this.notificationSwal('error','Error al Ingresar','Verifique que el usuario y contraseña sean correctos')
                 this.spinner=false
                 
             }
           

          }).catch(error=> {
              this.spinner=false
               this.notificationSwal('error','Error al Ingresar','Verifique que el usuario y contraseña sean correctos')
               console.log(error)
            })

        },
        notificationSwal(icon,title,text){
            Swal.fire({
            icon: icon,
            title: title,
            text: text,
            })
        }
    }
}
</script>
<style scoped src="@/assets/css/login.css"></style>